import { combineReducers } from "redux";
import { ADD_USER_REQUEST, FETCH_USERS_REQUEST } from "./constants";
import { CHANGE_USER_STATUS_REQUEST } from "../user/constants";
import { Action, UserItem } from "./types";
import { Action as UserAction } from "../user/types";
import { getFailureActionType, getSuccessActionType } from "../utils";

function items(state: UserItem[] = [], action: Action | UserAction): UserItem[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_USERS_REQUEST):
      return action.payload.data;

    case CHANGE_USER_STATUS_REQUEST:
      return state.map((user) => (user.id === action.data.userId ? { ...user, isFetching: true } : user));

    case getSuccessActionType(CHANGE_USER_STATUS_REQUEST):
      return state.map((user) =>
        user.id === action.data.userId ? { ...action.payload, isFetching: false } : user
      );

    case getFailureActionType(CHANGE_USER_STATUS_REQUEST):
      return state.map((user) => (user.id === action.data.userId ? { ...user, isFetching: false } : user));

    case getSuccessActionType(ADD_USER_REQUEST):
      return [...state, action.payload];

    default:
      return state;
  }
}

function pageCount(state: number = 0, action: Action): number {
  switch (action.type) {
    case getSuccessActionType(FETCH_USERS_REQUEST):
      return action.payload.pageCount;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_USERS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_USERS_REQUEST):
    case getFailureActionType(FETCH_USERS_REQUEST):
      return false;
    case ADD_USER_REQUEST:
      return true;
    case getSuccessActionType(ADD_USER_REQUEST):
    case getFailureActionType(ADD_USER_REQUEST):
      return false;

    default:
      return state;
  }
}

export const users = combineReducers({ items, pageCount, isFetching });
